import * as React from "react";
import { forwardRef } from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgDownloadAltIcon = ({ title, titleId, ...props }, ref) => /* @__PURE__ */ _jsxs("svg", {
	width: 25,
	height: 24,
	viewBox: "0 0 25 24",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	ref,
	"aria-labelledby": titleId,
	...props,
	children: [title ? /* @__PURE__ */ _jsx("title", {
		id: titleId,
		children: title
	}) : null, /* @__PURE__ */ _jsx("path", {
		fillRule: "evenodd",
		clipRule: "evenodd",
		d: "M2.75 17C2.75 19.6234 4.87665 21.75 7.5 21.75L17.5 21.75C20.1234 21.75 22.25 19.6234 22.25 17V13C22.25 10.3766 20.1234 8.25 17.5 8.25H17C16.5858 8.25 16.25 8.58579 16.25 9C16.25 9.41421 16.5858 9.75 17 9.75H17.5C19.2949 9.75 20.75 11.2051 20.75 13V17C20.75 18.7949 19.2949 20.25 17.5 20.25L7.5 20.25C5.70507 20.25 4.25 18.7949 4.25 17L4.25 13C4.25 11.2051 5.70507 9.75 7.5 9.75H8C8.41421 9.75 8.75 9.41421 8.75 9C8.75 8.58579 8.41421 8.25 8 8.25H7.5C4.87665 8.25 2.75 10.3766 2.75 13L2.75 17ZM8.96967 12.5303C8.67678 12.2374 8.67678 11.7626 8.96967 11.4697C9.26256 11.1768 9.73744 11.1768 10.0303 11.4697L11.75 13.1893L11.75 3C11.75 2.58579 12.0858 2.25 12.5 2.25C12.9142 2.25 13.25 2.58579 13.25 3L13.25 13.1893L14.9697 11.4697C15.2626 11.1768 15.7374 11.1768 16.0303 11.4697C16.3232 11.7626 16.3232 12.2374 16.0303 12.5303L13.0303 15.5303C12.7374 15.8232 12.2626 15.8232 11.9697 15.5303L8.96967 12.5303Z",
		fill: "currentColor"
	})]
});
const ForwardRef = forwardRef(SvgDownloadAltIcon);
export default ForwardRef;
